import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import toastsStore from "../../stores/singletones/ToastsStore";

type PaymentResult = "OK" | "ERROR";

export function usePaymentResult() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const result = params.get("result") as PaymentResult | null;

    if (result === "OK") {
      toastsStore.addToast({
        props: { animation: true, autohide: true, delay: 8000 },
        header: "Payment Successful",
        body: "Your payment has been processed successfully. Thank you!",
        variant: "success"
      });
      cleanupResultParam();
    } else if (result === "ERROR") {
      toastsStore.addToast({
        props: { animation: true, autohide: true, delay: 10000 },
        header: "Payment Failed",
        body: "There was an issue processing your payment. Please try again or contact support.",
        variant: "danger"
      });
      cleanupResultParam();
    }

    function cleanupResultParam() {
      const newParams = new URLSearchParams(location.search);
      newParams.delete("result");
      const newSearch = newParams.toString();
      history.replace({
        ...location,
        search: newSearch ? `?${newSearch}` : ""
      });
    }
  }, [location.search, history, location]);
}
